"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationProvider = exports.getLocaleMetaInfo = exports.isRtl = exports.PseudoLocale = exports.Locale = void 0;
var locales_1 = require("./locales");
Object.defineProperty(exports, "Locale", { enumerable: true, get: function () { return locales_1.Locale; } });
Object.defineProperty(exports, "PseudoLocale", { enumerable: true, get: function () { return locales_1.PseudoLocale; } });
var locales_utils_1 = require("./locales.utils");
Object.defineProperty(exports, "isRtl", { enumerable: true, get: function () { return locales_utils_1.isRtl; } });
Object.defineProperty(exports, "getLocaleMetaInfo", { enumerable: true, get: function () { return locales_utils_1.getLocaleMetaInfo; } });
var translation_provider_1 = require("./translation_provider");
Object.defineProperty(exports, "TranslationProvider", { enumerable: true, get: function () { return translation_provider_1.TranslationProvider; } });
//# sourceMappingURL=index.js.map